import { useCallback } from "react"
import { View } from "react-native"
import { useTheme } from "styled-rn"
import { useContextSelector } from "use-context-selector"

import { CollabAvatar } from "./CollabAvatar"
import { HEADER_CONTENT_AREA } from "./PlayGameHeader"
import { useIsMobile } from "../../hooks/useIsMobile"
import { playGameContext } from "../../hooks/useSetupPlayGameContext"
import { Row, BodyText, AnimatedPressableBase, BASE_MARGIN } from "../DesignSystem"
import { PopoverTooltip } from "../popovers/PopoverTooltip"
import { OverlayContext } from "../socialOverlay/OverlayContext"

export function PlayGameCollabAvatars() {
  const hasSidebarOpen = useContextSelector(OverlayContext, (c) => c.socialOverlay)
  const setSidebarOpen = useContextSelector(OverlayContext, (c) => c.setSocialOverlay)

  const collab = useContextSelector(playGameContext, (s) => s.gameUIState.collab)
  const collabs = useContextSelector(playGameContext, (s) => s.gameUIState.collabs)
  const isOnline = useContextSelector(playGameContext, (s) => s.gameUIState.isOnline)
  const isMobile = useIsMobile()
  const theme = useTheme()

  const Root = isMobile || hasSidebarOpen ? View : AnimatedPressableBase
  const openSidebar = useCallback(() => {
    setSidebarOpen(true)
  }, [setSidebarOpen])

  if (isMobile && (!isOnline || collab?.state === "connecting")) return null
  const max = isMobile ? 3 : 7
  const count = collabs.length
  // Show the max value, unless there are more than the max, then show max - 1 so there is space
  // for the 'and x more' text.
  const shouldLimit = count > max
  const toShow = shouldLimit ? collabs.slice(0, max - 1) : collabs
  const extras = shouldLimit ? collabs.slice(max - 1) : []

  return (
    <Root onPress={openSidebar}>
      <Row style={{ marginLeft: BASE_MARGIN / 2, alignItems: "center" }}>
        {toShow.map((collab, i) => {
          const margin = i === 0 ? 0 : -HEADER_CONTENT_AREA / 3
          return (
            <View style={{ zIndex: 100 - i }} key={collab.nID + i}>
              <CollabAvatar
                collab={collab}
                size={HEADER_CONTENT_AREA}
                style={{ marginLeft: margin, backgroundColor: theme.a_bg, width: HEADER_CONTENT_AREA, height: HEADER_CONTENT_AREA }}
              />
            </View>
          )
        })}

        {extras.length > 0 && (
          <PopoverTooltip text={extras.reduce((memo, collab) => `${memo}, ${collab.display}`, "")}>
            <View
              style={{
                height: HEADER_CONTENT_AREA,
                minWidth: HEADER_CONTENT_AREA,
                borderRadius: 100,
                padding: 8,
                paddingLeft: 6,
                backgroundColor: `${theme.fg}33`,
                justifyContent: "center",
                alignItems: "center",
                zIndex: -1,
              }}
            >
              <BodyText bold size="small">
                +{extras.length}
              </BodyText>
            </View>
          </PopoverTooltip>
        )}
      </Row>
    </Root>
  )
}
